import { storage } from "../firebase";
import { ref, uploadBytes } from "firebase/storage";

const BASE_PATH = 'profile/'

function makeid(length: number = 40) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

const pushProfileImage = async (file: File) => {
    const id = makeid()

    const fileExtensionSplit = file.name.split(".");
    const fileExtension = fileExtensionSplit[fileExtensionSplit.length - 1];

    const filename = `${id}.${fileExtension}`

    const result = await uploadBytes(ref(storage, `${BASE_PATH}/${filename}`), file)

    return result.metadata.name;
}

export {
    pushProfileImage
}